module.exports = __webpack_public_path__ + "img/home_menu_8_default.02701bc8.png";